import { TPage } from '@/shared/types/deprecated-types'

const routeBreadcrumbsMap: Record<string, TPage[]> = {
	'/about-iport': [{ id: '1', title: 'О компании', link: '/about-iport/' }],
	'/bank-details': [{ id: '1', title: 'Реквизиты', link: '/bank-details/' }],
	'/b2b': [{ id: '1', title: 'iPort для бизнеса' }],
	'/b2b/insurance': [
		{ id: '1', title: 'iPort для бизнеса', link: '/b2b' },
		{ id: '2', title: 'Страхование для бизнеса' }
	],
	'/b2b/leasing': [
		{ id: '1', title: 'iPort для бизнеса', link: '/b2b/' },
		{ id: '2', title: 'Лизинг' }
	],
	'/b2b/plus': [
		{ id: '1', title: 'iPort для бизнеса', link: '/b2b/' },
		{ id: '2', title: 'Карта преимуществ iPort+ для бизнеса' }
	],
	'/b2b/trade-in': [
		{ id: '1', title: 'iPort для бизнеса', link: '/b2b/' },
		{ id: '2', title: 'Обмен в Трейд-ин для бизнеса' }
	],
	'/blog': [{ id: '1', title: 'Блог' }],
	'/brand': [{ id: '1', title: 'Бренды', link: '/brand/' }],
	'/cart': [{ id: '1', title: 'Корзина', link: '/cart/' }],
	'/catalog': [{ id: '1', title: 'Каталог' }],
	'/catalog/aksessuary': [
		{ id: '1', title: 'Каталог', link: '/catalog' },
		{ id: '2', title: 'Аксессуары' }
	],
	'/compare': [{ id: '1', title: 'Сравнение', link: '/compare/' }],
	'/contacts': [{ id: '1', title: 'Контакты', link: '/contacts/' }],
	'/delivery': [{ id: '1', title: 'Доставка и оплата', link: '/delivery/' }],
	'/discount': [{ id: '1', title: 'Уценка', link: '/discount/' }],
	'/discount/catalog': [{ id: '1', title: 'Уценка', link: '/markdown/' }],
	'/enter': [{ id: '1', title: 'Авторизация', link: '/enter/' }],
	'/favorites': [{ id: '1', title: 'Избранное', link: '/favorites/' }],
	'/found-lower-price': [{ id: '1', title: 'Гарантия лучшей цены', link: '/found-lower-price/' }],
	'/gifts': [
		{ id: '1', title: 'Каталог', link: '/catalog/' },
		{ id: '2', title: 'Подарочные карты' }
	],
	'/guarantee': [{ id: '1', title: 'Гарантия', link: '/guarantee/' }],
	'/markdown': [{ id: '1', title: 'Уценка', link: '/markdown/' }],
	'/new': [{ id: '1', title: 'Новинки', link: '/new/' }],
	'/news': [{ id: '1', title: 'Новости' }],
	'/promo/iphone-18': [{ id: '1', title: 'Предзаказ на новый iPhone', link: '/promo/iphone-18/' }],
	'/return': [{ id: '1', title: 'Обмен и возврат', link: '/return/' }],
	'/sales': [{ id: '1', title: 'Акции' }],
	'/service': [{ id: '1', title: 'Сервисные центры' }],
	'/service/about-us': [
		{ id: '1', title: 'Сервисные центры', link: '/service/' },
		{ id: '2', title: 'С заботой о каждом устройстве. Ваш iPort.' }
	],
	'/service/for-business': [
		{ id: '1', title: 'Сервисные центры', link: '/service/' },
		{ id: '2', title: 'Сервисное обслуживание для бизнеса' }
	],
	'/service/insurance': [
		{ id: '1', title: 'Сервисные центры', link: '/service/' },
		{ id: '2', title: 'Ремонт по страховому полису' }
	],
	'/service/iport-card': [
		{ id: '1', title: 'Сервисные центры', link: '/service/' },
		{ id: '2', title: 'iPort+ Service' }
	],
	'/service/purchase-of-devices': [
		{ id: '1', title: 'Сервисные центры', link: '/service/' },
		{ id: '1', title: 'Обмен в Трейд-ин' }
	],
	'/service/warranty-repair': [
		{ id: '1', title: 'Сервисные центры', link: '/service/' },
		{ id: '2', title: 'Гарантийный ремонт' }
	],
	'/services': [{ id: '1', title: 'Услуги' }],
	'/services/care': [
		{ id: '1', title: 'Услуги', link: '/services/' },
		{ id: '2', title: 'Карта iPort+ Care' }
	],
	'/services/credit': [{ id: '1', title: 'Рассрочка и кредит', link: '/services/credit' }],
	'/services/credit/sber': [{ id: '1', title: ' Рассрочка от СберБанка', link: '/sber/' }],
	'/services/credit/t-bank': [{ id: '1', title: 'Кредит от Т-Банка', link: '/t-bank/' }],
	'/services/insurance': [
		{ id: '1', title: 'Услуги', link: '/services' },
		{ id: '2', title: 'Страхование' }
	],
	'/services/iport-card': [
		{ id: '1', title: 'Услуги', link: '/services/' },
		{ id: '2', title: 'Бонусная программа' }
	],
	'/services/plus': [
		{ id: '1', title: 'Услуги', link: '/services/' },
		{ id: '2', title: 'Карта преимуществ iPort+' }
	],
	'/services/trade-in': [
		{ id: '1', title: 'Услуги', link: '/services/' },
		{ id: '2', title: 'Обмен в Трейд-ин' }
	],
	'/shops': [{ id: '1', title: 'Магазины' }],
	'/sitemap': [{ id: '1', title: 'Карта сайта', link: '/sitemap/' }],
	'/space': [{ id: '1', title: 'Пространство возможностей', link: '/space/' }]
}

const normalizePathname = (pathname: string) => {
	if (!pathname) return '/'

	const trimmed = pathname.replace(/\/+$/, '')
	return trimmed || '/'
}

const getDynamicRouteBreadcrumbs = (pathname: string): TPage[] => {
	if (/^\/sales\/[^/]+$/.test(pathname)) {
		return [{ id: '1', title: 'Акции', link: '/sales/' }]
	}

	if (/^\/order\/success\/[^/]+$/.test(pathname)) {
		return [{ id: '1', title: 'Заказ успешно оформлен' }]
	}

	return []
}

export const getRouteBreadcrumbs = (pathname: string): TPage[] => {
	const normalizedPathname = normalizePathname(pathname)
	const dynamicRouteBreadcrumbs = getDynamicRouteBreadcrumbs(normalizedPathname)

	if (dynamicRouteBreadcrumbs.length > 0) {
		return dynamicRouteBreadcrumbs
	}

	return routeBreadcrumbsMap[normalizedPathname] || []
}
